<template>
    <div class="w-full rounded overflow-hidden mb-auto">
        <div class="p-4 bg-white w-full lg:border-b border-gray-200 block sm:hidden">
            <h3 class="font-bold text-xl page-title">{{ $__('opportunities.table_title') }}</h3>
        </div>
        <TableContent @sortColumn="sortColumn" :opportunities="this.filteredOpportunities" :sortBy="sortBy" :showSortIcon="true" />
        <TableFooter
            :itemsPerPageOptions="this.itemsPerPageOptions"
            :itemsPerPage="itemsPerPage"
            :currentPage="this.currentPage"
            :totalPages="this.totalPages"
            @changeItemsPerPage="changeItemsPerPage"
            @navigatePage="goToPage"
        />
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3';
import TableContent from "@/Components/Opportunities/Table/Content/Index";
import TableFooter from "@/Components/Opportunities/Table/Content/Footer";
import moment from 'moment';

export default {
    data: () => ({
        itemsPerPageOptions: [ 25, 50, 100, 250 ],
        itemsPerPage: 25,
        filteredOpportunities: [],
        sortedOpportunities: [],
        allOpportunities: [],
        sortBy: {
            column: '',
            asc: true,
        },
        currentPage: 1,
        totalPages: 1
    }),
    props: [ 'opportunities' ],
    components: {
        Link,
        TableFooter,
        TableContent,
    },
    methods: {
        changeItemsPerPage( option ) {
            this.itemsPerPage = option;
            this.currentPage = 1;

            this.filterOpportunities();
        },
        filterOpportunities() {
            this.filteredOpportunities.length = 0;
            const offset = ( this.currentPage * this.itemsPerPage ) - this.itemsPerPage;
            for (let i = offset; i < this.itemsPerPage; i++) {
                this.filteredOpportunities.push(this.sortedOpportunities[i]);
            }


            this.totalPages = Math.ceil(this.$props.opportunities.length / this.itemsPerPage);

            if (this.filteredOpportunities.length === 0) {
                this.totalPages = 1;
            }
        },
        goToPage( page ) {
            this.currentPage = page;
            this.filterOpportunities();
        },
        sortColumn: function (column, keepSortDirection = false) {
            const alreadySortingByColumn = this.sortBy.column === column;
            const sortInAscendingOrder = alreadySortingByColumn ? !this.sortBy.asc : true;

            this.sortBy = { column, asc: keepSortDirection ? this.sortBy.asc : sortInAscendingOrder };

            /*
            * Sort the columns differently based on whether the column contains
            * integers or strings
            * */
            let newSortedOpportunities = this.allOpportunities.sort(function (a, b) {
                const aColumn = a?.[column] || '';
                const bColumn = b?.[column] || '';

                if (Number.isInteger(aColumn) && Number.isInteger(bColumn)) {
                    return aColumn - bColumn;
                }

                return aColumn.localeCompare(bColumn);
            });

            if (this.sortBy.asc) {
                newSortedOpportunities = newSortedOpportunities.reverse();
            }

            this.sortedOpportunities = newSortedOpportunities;
            this.filterOpportunities();
        },
    },
    created () {
        this.allOpportunities = this.sortedOpportunities = this.opportunities.map(opportunity => {
            const unixCreatedDate = moment(opportunity.createdDate, 'DD-MM-YYYY').unix();
            return {...opportunity, unixCreatedDate: unixCreatedDate}
        });
        this.filterOpportunities();
    },
    updated() {
        this.filterOpportunities();
    },
    watch: {
        opportunities(newOpportunities) {
            this.allOpportunities = this.sortedOpportunities = newOpportunities.map(opportunity => {
                const unixCreatedDate = moment(opportunity.createdDate, 'DD-MM-YYYY').unix();
                return {...opportunity, unixCreatedDate: unixCreatedDate}
            });

            if (this.sortBy.column.length === 0) {
                return;
            }

            this.sortColumn(this.sortBy.column, true)
        }
    },
}

</script>
